"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.corsImport = void 0;
var loadjs_1 = __importDefault(require("loadjs"));
function corsImport(src) {
  var noCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var bundleId = noCache ? "".concat(src, "?t=").concat(Date.now()) : src;
  loadjs_1.default([src], bundleId, {
    before: function before(path, scriptEl) {
      scriptEl.crossOrigin = 'anonymous';
      // vite serves content as is and requires `module` type
      if (path.match(/\.tsx?/)) {
        scriptEl.type = 'module';
      }
    },
    numRetries: 6
  });
  return new Promise(function (resolve, reject) {
    var resolvedTyped = resolve;
    loadjs_1.default.ready(bundleId, {
      success: resolvedTyped,
      error: reject
    });
  });
}
exports.corsImport = corsImport;